"use strict";

exports.__esModule = true;

exports.default = function (strings, raw) {
  strings.raw = raw;
  return strings;
};


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/babel-runtime/helpers/taggedTemplateLiteralLoose.js
// module id = 9
// module chunks = 168707334958949